import { toast as sonnerToast } from 'vue-sonner'

export function showSuccess(message: string, duration = 1500) {
  sonnerToast.success(message, { duration })
}

export function showError(message: string, duration = 1500) {
  sonnerToast.error(message, { duration })
}

export function showWarning(message: string, duration = 1500) {
  sonnerToast.warning(message, { duration })
}

export function showInfo(message: string, duration = 1500) {
  sonnerToast.info(message, { duration })
}

export function showLoading(message: string) {
  return sonnerToast.loading(message)
}

export function showToast(message: string, duration = 1500) {
  sonnerToast(message, { duration })
}

/**
 * 关闭指定的 toast
 */
export function dismissToast(id: string | number) {
  sonnerToast.dismiss(id)
}

/**
 * 关闭所有 toast
 */
export function dismissAllToasts() {
  sonnerToast.dismiss()
}
